<template>
  <div class="form-nested-accordion">
    <div v-if="this.permissao">
      <div class="row">
        <div class="col-md-12">
          <p>Cadastre, Altere ou Exclua usuários de sua revenda, você pode criar quantos usuários achar necessário e disponibilizar a eles diferentes níveis de acesso às páginas do site.</p>
        </div>
      </div>
      <div id="new-edit-user">
        <form @submit.prevent="saveAction" v-on:keyup.enter="saveAction()" action="#" method="get">
          <div class="row">
            <div class="col-md-12">
                <h3 class="box-title">INFORMAÇÕES PESSOAIS</h3>
            </div>
          </div>
          <div class="row">
            <div>
              <FormHelper
                :inputVar="frmNewEditUser.usrId"
                :form="frmNewEditUser"
                type="hidden"
                label="id"
              ></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="frmNewEditUser.usrName"
                :form="frmNewEditUser"
                placeholder="Ex: José Santos"
                label="Nome"
              ></FormHelper>
            </div>
            <div class="col-md-6">
              <FormHelper
                :inputVar="frmNewEditUser.usrEmail"
                :form="frmNewEditUser"
                placeholder="Ex: um_email@provedor.com"
                label="Email"
                validationType="email"
              ></FormHelper>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <FormHelper
                :inputVar="frmNewEditUser.adminPass"
                :form="frmNewEditUser"
                placeholder=""
                label="Senha do Administrador "                
                type="text"
              ></FormHelper>
            </div>
            <div class="col-md-4">
              <FormHelper
                :inputVar="frmNewEditUser.usrPass"
                :form="frmNewEditUser"
                placeholder=""
                label="Senha"
                type="password"
              ></FormHelper>
            </div>
            <div class="col-md-4">
              <FormHelper
                :inputVar="frmNewEditUser.usrConfPass"
                :form="frmNewEditUser"
                :compareTo="frmNewEditUser.usrPass"
                validationType="comparison"
                placeholder=""
                label="Confirmar Senha"
                type="password"
              ></FormHelper>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">PERMISSÕES DE ACESSO</h3>
            </div>
          </div>
          <!-- Trocar o "value" dos checkboxs para o valor que corresponde com a permissão  -->
          <div class="row">
            <div class="col-md-2">
              <input id="permission-1" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="1"/>
              <label for="permission-1" style="margin-left: 5px">Acesso Total</label>
            </div>
            <div class="col-md-2">
              <input id="permission-2" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="2"/>
              <label for="permission-2" style="margin-left: 5px">Fazer Pedido</label>
            </div>
            <div class="col-md-2">
              <input id="permission-3" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="6"/>
              <label for="permission-3" style="margin-left: 5px">Consultar Financeiro</label>
            </div>
            <div class="col-md-2">
              <input id="permission-4" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="4"/>
              <label for="permission-4" style="margin-left: 5px">Fazer Cotação Express</label>
            </div>
            <div class="col-md-2">
              <input id="permission-5" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="5"/>
              <label for="permission-5" style="margin-left: 5px">Consultar Pedido</label>
            </div>
            <div class="col-md-2">
              <input id="permission-6" v-model="frmNewEditUser.checkedPerms" type="checkbox" value="3"/>
              <label for="permission-6" style="margin-left: 5px">Fazer RMA</label>
            </div>
          </div>
        </form>
        <div  class="row">
          <div class="col-sm-2">
            <div class="wrap-butons-line">
              <button aria-label="Salvar" class="btn primary-button stretch" v-on:click="saveAction">Salvar</button>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="wrap-butons-line">
              <button aria-label="Cancelar" class="btn primary-button stretch" v-on:click="returnToList">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
      <div id="list-user">
        <div class="row">
          <div class="col-md-12">
              <h3 class="box-title">USUÁRIOS CADASTRADOS EM SUA REVENDA</h3>
          </div>
        </div>
        <div class="row" style="margin-bottom:10px">
          <div class=" col-xs-6 col-md-6">
            <button aria-label="Abrir" class="btn primary-button" v-on:click="openForm">
              <i class="fa fa-plus-circle fa-lg"/>
            </button>
          </div>
          <div class="col-xs-6 col-md-6">
            <button aria-label="Abrir" class="btn primary-button pull-right"  type="button" data-toggle="modal" data-target="#contract-modal">
              <i class="fa fa-file-text fa-lg"/>
            </button>
            <div id="contract-modal" class="modal" tabindex="-1" role="dialog">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Contrato de Confidencialidade</h4>
                  </div>
                  <div class="modal-body">
                    <p>Os dados disponibilizados no Direct-Client são CONFIDENCIAIS e de uso exclusivo da Revenda, que é responsável pela correta utilização dos meios eletrônicos que lhe são disponibilizados, obedecendo às normas estabelecidas pela Aldo e fabricantes, cabendo a ela utilizá-los somente para os fins específicos, e obrigando-se por si, por seus funcionários e contratados a manter os códigos de acesso e as informações em sigilo e proibir o acesso de pessoas não autorizadas ou terceiros.</p>
                    <p>Caso a Revenda permita ou facilite o acesso de terceiros não autorizados, divulgue as informações do SITE (com ênfase nos preços e promoções) ou utilize-se do SITE para fins adversos aos aqui especificados FICA SUJEITA A PROCESSO JUDICIAL INDENIZATÓRIO elegendo-se o Foro da Comarca de Maringá - Paraná, por mais privilegiado que outro seja, por perdas e danos morais no valor de 100 (CEM) SALÁRIOS MÍNIMOS.</p>
                    <p>A concordância com os termos e condições expostas no SITE da Aldo se produzirá mediante cada acesso, que implica na declaração expressa da Revenda em conhecer e aceitar sem ressalvas ou restrições todos os termos e condições estabelecidas neste instrumento particular e nas condições comerciais estipuladas pela Aldo, bem como qualquer outro termo ou condição expresso nas consultas ou nos pedidos de compra que vier a realizar, salvo quando existir acordo específico entre as partes.</p>
                    <p>A Revenda está autorizada a divulgar as informações sobre características dos produtos contidas no SITE da Aldo, obedecendo, logicamente orientações de confidencialidade dos fabricantes.</p>
                  </div>
                  <div class="modal-footer">
                    <button aria-label="Fechar" type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" :key="reloadKey">
            <vue-good-table
                    :columns="columns" 
                    :rows="usersList" 
                    :pagination-options="{enabled: false}"
                    styleClass="vgt-table">
              <template slot="table-row" slot-scope="props" >
                <span v-if="props.column.field == 'delete'">
                  <a class="fa fa-trash-o fa-lg" style="color:red" v-on:click.prevent="deleteUser(props.row, $event)" href="#"/>
                </span>
                <span v-else-if="props.column.field == 'edit'">
                  <a class="fa fa-pencil fa-lg" style="color:gray" v-on:click.prevent="editUser(props.row)" href="#"/>
                </span>
                <span v-else-if="props.column.field == 'enabled'">
                  <span v-if="!props.row.enabled">
                    <a class="fa fa-toggle-on fa-lg" style="color:#5666a0" v-on:click.prevent="enableDisableUser(props.row, $event)" href="#"/>
                  </span>
                  <span v-else>
                    <a class="fa fa-toggle-off fa-lg" style="color:5666a0"  v-on:click.prevent="enableDisableUser(props.row, $event)" href="#"/>
                  </span>
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
              <div slot="emptystate">Sem dados para exibição</div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span style="margin-left: 2%; width:95%;" class="alert alert-danger font-size-0_8em">
      Usuários de Internet não podem alterar os demais usuários
    </span>
    </div>
  </div>
</template>
<script>

  var spinnerClass = "fa-spinner fa-spin";

  import "vue-good-table/dist/vue-good-table.css";
  import FormHelper from "../FormHelper.vue";
  import { VueGoodTable } from "vue-good-table";

  export default {
    name: 'UserControl',
    components: {
      VueGoodTable,
      FormHelper
    },
    computed: {
      formErrors: function () {
        // Retorna os campos que estão com erro de validação
        const errors = Object.keys(this.frmNewEditUser).filter((key) => this.frmNewEditUser[key].validation && !this.frmNewEditUser[key].validation.status)      
        return errors.length;
      }    
    },
    data() {
      return {
        frmNewEditUser: {
          //Campos do formulário para editar ou criar novo usuário
          attemptSubmit: false,

          usrId: new  this.formInput(false, ""),
          usrName: new this.formInput(true),
          usrEmail: new this.formInput(true),
          usrPass: new this.formInput(true),
          usrConfPass: new this.formInput(true),
          adminPass: new this.formInput(true),
          checkedPerms: []      
        },
        senhaAdmin: '',
        permissao: true,
        //Colunas da tabela
        columns: [
          { label: "Ativo", field: "enabled", tdClass: "align-center-td", thClass: "align-center-td" },
          { label: "Nome", field: "name" },
          { label: "Email", field: "email" },
          { label: "Editar", field: "edit", tdClass: "align-center-td", thClass: "align-center-td" },
          { label: "Excluir", field: "delete", tdClass: "align-center-td", thClass: "align-center-td" }
        ],
        //Lista de usuários
        usersList: [],
        //Variável para forçar o reload da tabela
        reloadKey: 0
      }
    },
    mounted(){

      //Executa quando renderiza a página
      this.returnToList();
      this.reloadUsersTable();

      const self = this;

       $.ajax({
          url: this.$apiUrl + "Session.svc/getsessions",
          dataType: "json",
          type: "GET",
          xhrFields: { withCredentials: true },
          success: data => {
              if (data.DadosCliente != null){
                let cliente = data.DadosCliente
                self.senhaAdmin = cliente.CliSenha
              }
          }
      });
    },
    methods:{
      forceUpdateTable: function(){
        //Método para foçar o reload da tabela
        this.reloadKey += 1;
      },
      enableDisableUser: function(user, event){
        //Método que faz as chamadas para habilitar ou desabilitar o usuário
        var $component = jQuery(event.target);
        var onClass = "fa-toggle-on";
        var offClass = "fa-toggle-off";

        var xhr = new XMLHttpRequest()
        xhr.onload = () => {            
            if (xhr.status == 200){
              swal({
                title: "Usuário Alterado com Sucesso",
                icon: "success"
              }).then(() => (location.href = window.location.href))
            }
            else{
              swal({
                title: "Erro ao alterar usuário",
                icon: "error"
              })
            }

        }
        if ($component.hasClass(onClass))
        {
          $component.removeClass(onClass);
          $component.addClass(spinnerClass);
          //Fazer a chamada para desabilitar o usuário          
          xhr.open("POST", this.$apiUrl + "Usuariosnet.svc/ativardesativarusuariointernet")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({
            codigoUsuario: user.id
          }))
        }
        else
        {
          $component.removeClass(offClass);
          $component.addClass(spinnerClass);
          //Fazer a chamada para habilitar o usuário
          xhr.open("POST", this.$apiUrl + "Usuariosnet.svc/ativardesativarusuariointernet")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({
            codigoUsuario: user.id
          }))
        }
      },
      deleteUser: function(user, event){
        //Método que faz a chamada para deletar o usuário
        var $component = jQuery(event.target);
        var deleteClass = "fa-trash-o";
        var msg = "Deseja realmente deletar o usuário: " + user.name + " ?"
        if(confirm(msg)){
          $component.removeClass(deleteClass).addClass(spinnerClass);
          //Fazer a chamada para deletar o usuário
          var xhr = new XMLHttpRequest()
          xhr.onload = () => {            
            if (xhr.status == 200){
              swal({
                title: "Usuário Excluído com Sucesso",
                icon: "success"
              }).then(() => (location.href = window.location.href))
            }
            else{
              swal({
                title: "Erro ao excluir usuário",
                icon: "error"
              })
            }
          }
          xhr.open("POST", this.$apiUrl + "Usuariosnet.svc/deletarusuariointernet")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({
            codigoUsuario: user.id
          }))
        }

      },
      openForm: function(){
        //Método para ocultar a lista a abrir o formulário
        jQuery("#list-user").hide();
        jQuery("#new-edit-user").show();

      },
      returnToList: function(){
        //Método para fechar e limpar o formulário, e abrir a lista
        this.clearInputs();
        jQuery("#list-user").show();
        jQuery("#new-edit-user").hide();

      },
      editUser: function(user){
        //Método para preencher o formulário com o usuário selecionado para editar
        this.frmNewEditUser.usrId.value = user.id;
        this.frmNewEditUser.usrName.value = user.name;
        this.frmNewEditUser.usrEmail.value = user.email;
        this.frmNewEditUser.usrPass.value = user.pass;
        this.frmNewEditUser.usrConfPass.value = user.pass;        
        
        const self = this;

        var xhr = new XMLHttpRequest()
        xhr.onload = () => {
          if (xhr.status == 200){            
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {           
              self.frmNewEditUser.checkedPerms.push(element.ModCodigo)            
            }) 
          }
        }

        xhr.open("POST", this.$apiUrl + "Usuariosnet.svc/modulosautorizados")
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.withCredentials = true
        xhr.send(JSON.stringify({
          codigoUsuario: user.id
        }))

        this.openForm();

      },
      saveAction: function(){
        //Método chamando quando clica o botão "Salvar" do formulário
        this.frmNewEditUser.attemptSubmit = true;

        var errors = this.formErrors;
        if(errors){//Caso haja erro nos campos, retorna para não fazer a chamada
          return;
        }

        let permissoes = this.checkboxToString(this.frmNewEditUser.checkedPerms)
        var id = this.frmNewEditUser.usrId.value
        if(id !== ""){//Verifica se está editando um usuário ou criando novo
          //Chama método que salva a edição do usuário
          this.saveEditedUser(permissoes);
        }else{
          //Chama método que cria um novo usuário
          this.saveNewUser(permissoes);
        }

      },
      saveEditedUser: function(permissoes){
        //Fazer a chamada para salvar a edição do usuário
        // console.log("permissoes " + permissoes)
        let xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200 && xhr.responseText.includes("true")){
              swal({
                title: "Usuário Alterado com Sucesso",
                icon: "success"
              }).then(() => (location.href = window.location.href))                  
            }
            else if (xhr.status == 400){
              swal({
                title: "Senha do Administrador Inválida",
                icon: "error"
              })
            } 
            else if (xhr.responseText.includes("false"))
            {
              swal({
                title: "Email já sendo utilizado por outro revenda!",
                icon: "warning"
              })
            }
          }          
                    
          xhr.open("POST", this.$apiUrl + "Cliente.svc/editarusuariointernet")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({
            codigoUsuarioInternet: this.frmNewEditUser.usrId.value,
            senhaAtual: this.frmNewEditUser.adminPass.value,
            novaSenha: this.frmNewEditUser.usrPass.value,
            nome: this.frmNewEditUser.usrName.value,
            email: this.frmNewEditUser.usrEmail.value,
            permissoes: permissoes
          }))
                
      },
      saveNewUser: function(permissoes){
        //Fazer a chamada para salvar novo usuário
        let xhr = new XMLHttpRequest()
          xhr.onload = () => {            
            if (xhr.status == 200 && xhr.responseText.includes("true")){
              swal({
                title: "Usuário Cadastrado com Sucesso",
                icon: "success"
              }).then(() => (location.href = window.location.href))                  
            }
            else if (xhr.status == 400){
              swal({
                title: "Senha do Administrador Inválida",
                icon: "error"
              })
            } 
            else if (xhr.responseText.includes("false"))
            {
              swal({
                title: "Email já sendo utilizado por outro revenda!",
                icon: "warning"
              })
            }
          }          
                    
          xhr.open("POST", this.$apiUrl + "Cliente.svc/cadastrarusuariointernet")
          xhr.setRequestHeader("Content-type", "application/json")
          xhr.withCredentials = true
          xhr.send(JSON.stringify({           
            senhaAtual: this.frmNewEditUser.adminPass.value,
            novaSenha: this.frmNewEditUser.usrPass.value,
            nome: this.frmNewEditUser.usrName.value,
            email: this.frmNewEditUser.usrEmail.value,
            permissoes: permissoes
          }))                                   
      },
      checkboxToString: function(array){
        //Transforma o array de permissões dos checkboxs em String
        var values = "";
        array.forEach(function (element, index){
          if (index == array.length - 1)
            values = values.concat(element);
          else 
            values = values.concat(element + ";");
        });

        return values;

      },
      stringToCheckbox: function(value){
        //Transforma a String de permissões em array para os checkboxs
        var array = value.split(";");
        return array;
      },
      clearInputs: function() {
        //Limpa o formulário
        this.frmNewEditUser.attemptSubmit = false;
        this.frmNewEditUser.usrId.value = "";
        this.frmNewEditUser.usrName.value = "";
        this.frmNewEditUser.usrEmail.value = "";
        this.frmNewEditUser.adminPass.value = "";
        this.frmNewEditUser.usrPass.value = "";
        this.frmNewEditUser.usrConfPass.value = "";
        this.frmNewEditUser.checkedPerms = []
      },
      reloadUsersTable(){
        //Faz a chamada da lista de usuários e atualiza a tabela
        var self = this;

        var xhr = new XMLHttpRequest();
        xhr.onload = () => {
          if (xhr.status == 200) {
            self.usersList = [];
            var data = JSON.parse(xhr.responseText);
            data.forEach(element => {
              let user = {};
              user.id = element.UsrCodigo;
              user.name = element.UsrNome;
              user.email = element.UsrEmail;
              user.pass = element.UsrSenha;
              user.enabled = element.UsrAtivo == 1 ? true : false;
              self.usersList.push(user);
            });
            self.forceUpdateTable();
          }
          else if (xhr.status == 401){
            this.permissao = false;
          }
        }

        xhr.open("GET", this.$apiUrl + "Cliente.svc/getusuariosinternetcliente");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.withCredentials = true;
        xhr.send();

      },
      formInput: function(required, value) {
        // Define um padrão para estrutura de cada input do formulário
        this.required = required !== undefined ? required : true;
        this.value = value !== undefined ? value : "";

        this.validation = {
          // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
          // Para que o usuário seja barrado em caso de um submit sem dados
          status: !(this.required && this.value === ""),
          message: this.required ? "Por favor, preencha o campo acima" : ""
        };
      },
    }
  }
</script>